import { Edit, Info, Save } from '@mui/icons-material';
import { Box, Button, Card, CardContent, CardHeader, Container, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs';
import { AuthStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import { LoadingButton } from '@mui/lab';

const breadcrumbItem = { '/admin': 'Home', '': 'Daftar OPD' };

const Opd = () => {
    const logOut = AuthStore((state) => state.logOut);
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [menyimpan, setMenyimpan] = useState(false)
    const [verifikator, setVerifikator] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        _method: 'PUT',
        id_opd: "",
        verifikator: ""
    })

    const handleOpenDialog = (params) => {
        setFormData({
            ...formData,
            id_opd: params.id_opd,
            verifikator: params.validator === null ? '' : params.validator.username
        })
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    useEffect(() => {
        axios.get(
            base_url + '/get-verifikator',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                setVerifikator(response.data)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.status + " " + error.response.statusText,
                        text: error.response.data.message
                    })
                }
            })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menyimpan]);

    const requestData = () => {
        // setTableLoading(true)
        axios.get(
            base_url + '/admin/get-opd',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                setTableData(response.data)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.status + " " + error.response.statusText,
                        text: error.response.data.message
                    })
                }
            })
    }

    const handleChangeVerif = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const updateValidatorOpd = () => {
        console.log(formData);
        setLoading(true);
        axios.post(
            base_url + '/admin/update-validator-opd',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })
                console.log(response);
                handleCloseDialog()
                setMenyimpan(!menyimpan)
                setLoading(false)
                // navigate(-1)
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.status + " " + error.response.statusText,
                        text: error.response.data.message
                    })
                }
                setLoading(false)
                handleCloseDialog()
            })
    }

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="ADMIN" />
            <Container sx={{ my: 3 }} fixed>
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12}>
                        <Card variant='outlined'>
                            <CardHeader
                                title="Daftar OPD"
                            />
                            <CardContent>

                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center'>Action</TableCell>
                                                <TableCell>OPD</TableCell>
                                                <TableCell>Bendahara Pengeluaran</TableCell>
                                                <TableCell>Bendahara Pengeluaran Pembantu</TableCell>
                                                <TableCell>Validator</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>

                                            {tableData.map((item) => (
                                                <TableRow
                                                    key={item.id_opd}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell align='center'>
                                                        <Stack direction="row" spacing={1} justifyContent="center">
                                                            <Tooltip title="Info">
                                                                <IconButton aria-label="confirm" color='success' onClick={() => handleOpenDialog(item)}>
                                                                    <Info />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Edit">
                                                                <IconButton
                                                                    aria-label="edit"
                                                                    color="info"
                                                                    onClick={() => handleOpenDialog(item)}
                                                                >
                                                                    <Edit />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.nm_opd}
                                                    </TableCell>
                                                    <TableCell>
                                                        {
                                                            item.bendahara_pengeluaran.length > 0 ?
                                                                item.bendahara_pengeluaran.length > 1 ?
                                                                    item.bendahara_pengeluaran[0].nama + ', dkk'
                                                                    :
                                                                    item.bendahara_pengeluaran[0].nama
                                                                :
                                                                '-'
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {
                                                            item.bendahara_pengeluaran_pembantu.length > 0 ?
                                                                item.bendahara_pengeluaran_pembantu.length > 1 ?
                                                                    item.bendahara_pengeluaran_pembantu[0].nama + ', dkk'
                                                                    :
                                                                    item.bendahara_pengeluaran_pembantu[0].nama
                                                                :
                                                                '-'
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.validator === null ? '-' : item.validator.nama}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>

            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                <DialogTitle>Pilih Validator</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Pilih salah satu Validator dibawah
                    </DialogContentText>
                    <Box
                        noValidate
                        component="form"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            m: 'auto',
                            width: 'fit-content',
                        }}
                    >
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 250 }}>
                            <InputLabel id="demo-simple-select-standard-label">Validator</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={formData.verifikator}
                                onChange={handleChangeVerif}
                                label="Age"
                                name="verifikator"
                                fullWidth
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {
                                    verifikator.map((verif) => (
                                        <MenuItem key={verif.username} value={verif.username}>{verif.nama}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color='error' onClick={handleCloseDialog}>Tutup</Button>
                    <LoadingButton variant='contained' onClick={updateValidatorOpd} startIcon={<Save />} loading={loading}>Simpan</LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Opd